module.exports = __webpack_public_path__ + "media/dogs/two-dogs-talk-e82cc747.svg";